import { RoomsPage } from "apps/oneOnboarding/rooms/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(RoomsPage, "RoomsPage");
